import { makeAutoObservable } from "mobx";

interface MiscObject {
  growthbook?: boolean;
  growthbookAttributes?: boolean;
  segment?: boolean;
}

class Misc {
  growthbook = false;
  growthbookAttributes = false;
  segment = false;

  constructor() {
    makeAutoObservable(this);
  }

  setMisc(misc_: MiscObject): void {
    if (misc_.growthbook !== undefined) {
      this.growthbook = misc_.growthbook;
    }
    if (misc_.growthbookAttributes !== undefined) {
      this.growthbookAttributes = misc_.growthbookAttributes;
    }
    if (misc_.segment !== undefined) {
      this.segment = misc_.segment;
    }
  }
}

export default Misc;
